import { renderScore } from "../RenderMethods";
import { scoreHelper } from "../../../../../helpers/scoreHelper/scoreHelper";
export var renderLiveScore = function (event) {
    var score = scoreHelper(event);
    return renderScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard);
};
//# sourceMappingURL=renderLiveScore.js.map